import type { WritingTask } from './types'

export function localDateKey(date = new Date()) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

export function taskDueState(
  task: Pick<WritingTask, 'dueDate' | 'status' | 'archived'>,
  today: string,
) {
  if (!task.dueDate || task.status === 'done' || task.archived) return 'none'
  if (task.dueDate < today) return 'overdue'
  return task.dueDate === today ? 'today' : 'upcoming'
}

export function assignedTaskSummary(
  tasks: { dueDate: string }[],
  today: string,
) {
  return {
    open: tasks.length,
    today: tasks.filter((task) => task.dueDate === today).length,
    overdue: tasks.filter((task) => task.dueDate && task.dueDate < today)
      .length,
  }
}
